import React from "react";
import styled from "styled-components";
import ImageEcoCell from "../../assets/product/eco-cell.png";
import ImageHappiness from "../../assets/product/happiness.png";
import ImageTime from "../../assets/product/time.png";
import ImageStopwatch from "../../assets/product/stopwatch.png";
import ImageCheck from "../../assets/product/check-circular-button.png";
import { r, getThemeColor } from "../utils";

const iconSourceMap = {
  stopwatch: ImageStopwatch,
  time: ImageTime,
  eco: ImageEcoCell,
  happy: ImageHappiness,
  check: ImageCheck
};

const Icon = styled.div`
  position: relative;
  border: 1px solid black;
  height: 12.5rem;
  width: 8.125rem;
  ${r("margin", "1.5rem", ".5rem .75rem")};
  &:hover {
    border: 1px solid ${getThemeColor("teal")};
  }
`;

const Image = styled.img`padding-top: 3rem;`;

const Text = styled.div`padding-bottom: 3rem;`;

const Description = styled.div`
  position: absolute;
  top: 0;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: .5rem;
  color: white;
  font-size: 1rem;
  text-align: center;
  transition: opacity 300ms;
  cursor: default;
  &:hover {
    opacity: 1;
    background-color: ${getThemeColor("teal")};
  }
`;

const ImageAndText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

export default ({ src = "", tag = "", description = "" }) =>
  <Icon>
    <ImageAndText>
      <Image src={iconSourceMap[src]} />
      <Text>
        {tag}
      </Text>
    </ImageAndText>
    <Description>
      {description}
    </Description>
  </Icon>;



// WEBPACK FOOTER //
// ./src/components/Icon.js